import { Typography } from '@mui/material';
import i18next from 'i18next';
import { memo } from 'react';

import { shouldShowNoHours } from '../../../../utils/multi-store/hours';
import { MultiStoreHourChip } from './multi-store-hour-chip';
import { MultiStoreLoadingHours } from './multi-store-loading-hours';

interface MultiStoreHoursProps {
  hours: string[];
  // orari liberi solo negli altri centri inclusi, con il puntino
  elsewhereHours: string[];
  hourSelected?: string;
  isPending: boolean;
  isAfterMaxDay: boolean;
  // centri alternativi che stanno ancora caricando gli orari del giorno
  loadingIds: string[];
  onSelect: (hour: string) => void;
}

// Orari liberi in almeno un centro incluso, con lo stile dei chip dell'HourPicker
export const MultiStoreHours = memo(function MultiStoreHours({
  hours,
  elsewhereHours,
  hourSelected,
  isPending,
  isAfterMaxDay,
  loadingIds,
  onSelect,
}: MultiStoreHoursProps): JSX.Element | null {
  if (isPending) return null;

  if (shouldShowNoHours(hours, loadingIds)) {
    return (
      <div className="multi-store-empty">
        <Typography variant="contentDescription1">
          {i18next.t(
            isAfterMaxDay
              ? 'pages.when.dates_no_programmed'
              : 'pages.when.disclaimer'
          )}
        </Typography>
      </div>
    );
  }

  // unione ancora vuota ma con centri da caricare: "nessun orario" potrebbe essere falso
  if (hours.length === 0) return <MultiStoreLoadingHours />;

  return (
    <div className="multi-store-hours">
      {hours.map((hour) => (
        <MultiStoreHourChip
          key={hour}
          hour={hour}
          isSelected={hour === hourSelected}
          isElsewhereOnly={elsewhereHours.includes(hour)}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
});
